import React, { useState } from 'react';
import './Home.css';
import {useLocation, useNavigate} from "react-router-dom";
import apiClient from "../api/pufBarClientApi"; // Optional: for styling

const Home = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [userData, setUserData] = useState({});
    const [error, setError] = useState('');
    const history = useNavigate();

    const msgData = {text: "Incorrect credentials: Login Failed!", type: "info"};
    const location = useLocation();
    const message = location.state?.message;

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!username || !password) {
                setError('Please enter both username and password.');
                return;
            }

            const response = await apiClient.post('/login',  {
                    username: username,
                    password: password
                }
            );

            if (JSON.stringify(response?.data) === '{}') {
                setUsername('');
                setPassword('');
                history('/acsMbsaqip', {replace: true, state: {message: msgData}});
            }
            else if (response?.data) {
                const myObject = JSON.stringify(response.data, null, 2);
                setUserData(myObject);
                history('/dashboard', {replace: true, state: response.data});
            }

        } catch (error) {

            console.error('Login failed:', error.response ? error.response.data : error.message);
            setError('Invalid username or password.');
        }
    };

    return (
        <>
            <div className="login-form-container">
                { message ? (
                    <p style={{color: 'red'}}>{message.text}</p>
                ):(
                    <p></p>
                )
                }
                <h3>USER LOGIN</h3>
                <div className="form-group">
                    <form onSubmit={handleSubmit}>
                        <div className="side-by-side">
                            <label htmlFor="username">User ID:</label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className="side-by-side">
                            <label htmlFor="password">Password:</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="login-button">
                            <button className="my-button" type="submit">Sign in</button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="app-div">
                <p>For assistance, please contact <a href="mailto: nsqiptech@facs.org"
                                                     target="_blank">nsqiptech@facs.org</a></p>
            </div>
        </>
    );
};

export default Home;